/*
    Set focus on search field on page load.
*/
const searchFocus = {
    init: () => {
        document.addEventListener( "DOMContentLoaded", function () {
            const searchField = document.querySelector( 'body.search .search-form .search-field' );
            if ( searchField ) {
                searchField.focus();
            }
        } );
    }
}

export default searchFocus;